import React, { useState, useEffect } from 'react';
import {
    Container,
    Row,
    Col,
    Button,
    Input,
    Card,
    CardBody,
    CardHeader
} from "reactstrap";
import { Link, Redirect, withRouter } from "react-router-dom";
import {Table, Thead, Tbody, Tr, Th, Td} from 'react-super-responsive-table';
import {Ref} from "semantic-ui-react";
import { ReactSortable } from "react-sortablejs";

//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';

import { connect } from 'react-redux';


import { getDashboardData } from '../../store/actions';
import Select from "react-select";
//i18n
import { withNamespaces } from 'react-i18next';
import moment from "moment";
import {AvField, AvForm} from "availity-reactstrap-validation";
import { Tabs, Tooltip } from 'antd';
import toastr from "toastr";
import Media from "../contents/content";
import { paramPut, paramPost } from "../../apiHelpers/commonApiHelper";
import { getDetailedCampains } from '../../store/actions';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const { TabPane } = Tabs;





const ScreenDetail = (props) => {


    useEffect(() => {
        props.getDetailedCampains({id: props.match.params.player_id});
    }, [])

    useEffect(() => {
        if(props.detailed_campaigns && props.detailed_campaigns.length > 0) {
            setList(props.detailed_campaigns[0].player_campaigns.sort((a, b) => (a.order_number > b.order_number) ? 1 : -1));
        }
    }, [props.detailed_campaigns])

    const [pending, setPending] = useState(-1)
    const [list, setList] = useState(undefined)
    const [processing, setProcessing] = useState(false)

    const campaignList = () => {
        if(props.detailed_campaigns && props.detailed_campaigns[0].player_campaigns) {
            return props.detailed_campaigns[0].player_campaigns.map((item, index) => {
                return (
                    <Row style={{backgroundColor: "#dfdfdf", padding: "10px"}} className="mb-2" key={index}>
                        <Col xs={6}>
                            {item.campaign.media_campaigns[0].medium.media_type === "image" ? (
                                <img src={item.campaign.media_campaigns[0].medium.url} style={{width: "150px", height: "90px"}} />
                            ) : item.media_type === "video" ? (
                                <video style={{width: "150px", height: "90px"}}>
                                    <source src={item.campaign.media_campaigns[0].medium.url} type="video/mp4" />
                                </video>
                            ) : ""}
                        </Col>
                        <Col xs={4} style={{margin: "auto"}}>
                            <h4>{item.campaign.name}</h4>
                        </Col>
                        <Col xs={2} style={{fontSize: "20px", margin: "auto"}}>
                            <Tooltip title={"Unpublish campaign"}>
                                {pending === index ? <i className="bx bx-loader bx-spin align-middle"></i> : (
                                <i className="fa fa-minus-circle" style={{cursor: "pointer"}} onClick={() => handleUnPublish(item.id, index)}></i>
                                )}
                            </Tooltip>
                        </Col>
                    </Row>
                )
            })
        }
    }


    const handleUnPublish  = (id, index) => {
        setPending(index)
        paramPost('/api/v1/campaigns/unpublish', {id: id})
            .then((result) => {
                setPending(-1);
                if(result.status === 200) {
                    toastr.success(result.data.message, "Success");
                    props.getDetailedCampains({id: props.match.params.player_id});
                } else {
                    toastr.error(result.data.message, "Error");
                }
            })
            .catch(err => {
                setPending(-1);
                toastr.error("Something went wrong", "Error");
            })
    }

    const ContentList = ({ item, index }) => {
        return (
            <Draggable draggableId={`${item.id}`} index={index}>
                {provided => (
                    <Ref innerRef={provided.innerRef}>
                    <Tr
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                    >
                        <Td>{item.campaign.name}</Td>
                        <Td>
                            {item.campaign.media_campaigns[0].medium.media_type === "image" ? (
                                <img src={item.campaign.media_campaigns[0].medium.url} style={{width: "150px", height: "90px"}} />
                            ) : item.campaign.media_campaigns[0].medium.media_type === "video" ? (
                                <video style={{width: "150px", height: "90px"}}>
                                    <source src={item.campaign.media_campaigns[0].medium.url} type="video/mp4" />
                                </video>
                            ) : ""}
                        </Td>
                        <Td>
                            {moment(item.created_at).format("llll")}
                        </Td>
                        <Td>
                            <Tooltip title={"Unpublish campaign"}>
                                {pending === index ? <i className="bx bx-loader bx-spin align-middle action-cursor"></i> : (
                                    <i className="fa fa-minus-circle action-cursor" style={{cursor: "pointer"}} onClick={() => handleUnPublish(item.id, index)}></i>
                                )}
                            </Tooltip>
                        </Td>
                    </Tr>
                    </Ref>
                )}
            </Draggable>
        );
    };

    const QuoteList = React.memo(function QuoteList({ quotes }) {
        console.log("Items ==", quotes);
        return quotes.map((quote, index) => (
            <ContentList item={quote} index={index} key={quote.id} />
        ));
    });

    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    };

    function onDragEnd(result) {
        if (!result.destination) {
            return;
        }

        if (result.destination.index === result.source.index) {
            return;
        }


        const contents = reorder(
            list,
            result.source.index,
            result.destination.index
        );
        setList(contents);
    }

    const handleReorder = () => {
        let values = list
        let params = [];
        values.forEach((item, index) => {
            params.push({id: item.id, fb_id: item.fb_campaign_id, order: index + 1});
        });
        console.log("Req params ==", params);
        setProcessing(true);
        paramPost('/api/v1/campaigns/reorder', {info: params})
            .then(res => {
                setProcessing(false);
                if(res.status === 200) {
                    toastr.success(res.data.message, "Success");
                } else {
                    toastr.error(res.data.message, "Error");
                }
                console.log(res);
            })
            .catch(err => {
                toastr.error("Failed to reorder the campaigns", "Error");
                setProcessing(false);
                console.log(err);
            })
    }


    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div className="table-rep-plugin">
                        <div
                            className="table-responsive mb-0"
                            data-pattern="priority-columns"
                        >
                            <Table
                                id="tech-companies-1"
                                className="table table-striped table-bordered content-table"
                            >
                                <Thead>
                                    <Tr>
                                        <Th data-priority="1">Campaign Name</Th>
                                        <Th data-priority="1">Campaign</Th>
                                        <Th data-priority="1">Created at</Th>
                                        <Th data-priority="1">Action</Th>
                                    </Tr>
                                </Thead>
                                {list && (
                                    <DragDropContext onDragEnd={onDragEnd}>
                                        <Droppable droppableId="list">
                                            {provided => (
                                                <Ref innerRef={provided.innerRef}>
                                                <Tbody {...provided.droppableProps}>
                                                    <QuoteList quotes={list} />
                                                    {provided.placeholder}
                                                </Tbody>
                                                </Ref>
                                            )}
                                        </Droppable>
                                    </DragDropContext>
                                )}
                            </Table>
                        </div>
                    </div>
                </Container>
            </div>
            <div className="publish-row">
                <div className="state-save">
                    {/*<button className="btn btn-primary">Preview</button>*/}
                    <button className="btn btn-orange" onClick={() => handleReorder() } disabled={processing}>
                        {!processing ? "Save Reordered Campaign" : (
                            <React.Fragment>
                                <i className="bx bx-loader bx-spin font-size-16 align-middle mr-2"></i>
                                Saving
                            </React.Fragment>
                        )}
                    </button>
                </div>
            </div>
        </React.Fragment>
    );
}

const mapStateToProps = state => {
    const { loading, detailed_campaigns } = state.ScreenReducer;
    return { loading, detailed_campaigns };
}

export default withRouter(connect(mapStateToProps, { getDetailedCampains })(withNamespaces()(ScreenDetail)));
